"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paginator = exports.Pagination = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const Paginator_1 = require("@reactionable/core/lib/ui/paginator/Paginator");
const Pagination_1 = tslib_1.__importDefault(require("react-bootstrap/Pagination"));
function Pagination(props) {
    return (jsx_runtime_1.jsx(Pagination_1.default, { children: jsx_runtime_1.jsx(Paginator_1.Pagination, Object.assign({}, props, { PaginationLinkComponent: Pagination_1.default.Item, PaginationEllipsisComponent: Pagination_1.default.Ellipsis, PaginationLinkFirstComponent: Pagination_1.default.First, PaginationLinkPrevComponent: Pagination_1.default.Prev, PaginationLinkNextComponent: Pagination_1.default.Next, PaginationLinkLastComponent: Pagination_1.default.Last }), void 0) }, void 0));
}
exports.Pagination = Pagination;
function Paginator(props) {
    return jsx_runtime_1.jsx(Paginator_1.Paginator, Object.assign({}, props, { PaginationComponent: Pagination }), void 0);
}
exports.Paginator = Paginator;
//# sourceMappingURL=Paginator.js.map